export default __webpack_public_path__ + "static/media/reminder.d9760721.svg";